var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-md purchase-orders-summary full-height",class:{
    toggled: _vm.isToggled
}},[_c('div',{staticClass:"container body full-height"},[(_vm.userIsLogged)?_c('div',{staticClass:"main_container"},[_c('zee-sidebar-menu'),_vm._v(" "),_c('zee-topbar-menu'),_vm._v(" "),_c('div',{staticClass:"right_col",attrs:{"role":"main"}},[_c('router-view'),_vm._v(" "),_c('vue-progress-bar')],1)],1):_c('div',{staticClass:"full-height"},[_c('router-view',{attrs:{"name":"login-view"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"signup-view"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-210f43d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 370
// module chunks = 0